import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as types from '../../../constants/actionTypes';
import PropTypes from 'prop-types';
import { actions as supportActions } from '../../../actions/supportActions';
import { actions as projectLocationActions } from '../../../actions/projectLocationActions';
import { actions as projectActions } from '../../../actions/projectActions';
import Drawer from '../../Common/Drawer/Drawer';
import Notification from '../../Common/Notification';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import Button from '../../Common/Button';
import Icon from '../../Common/Icon';
import InputText from '../../Common/InputText';
import TextArea from '../../Common/TextArea';
import DatePicker from '../../Common/DatePicker/DatePicker';
import './Projects.scss';
import Toggle from '../../Common/Toggle/Toggle';
import { DATE_FORMAT } from '../../../constants/constants';
import Moment from 'moment';
import { PROJECT_LOCATION_WAIVER_STATUSES as waiverStatuses } from '../../../constants/constants';

export class ProjectsWidgetDrawer extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			isLoading: true,
			showContactForm: false,
			isCreateTicketFormValid: true,
			isUpdateProjectFormValid: true,
			contactSubject: '',
			contactDescription: '',
			projectCoaches: [],
			projectManagers: [],
			projectLocationEpicDates: [],
			isProjectNameChanged: false,
			isProjectCoachChanged: false,
			isProjectManagerChanged: false,
			isZeroDateChanged: false,
			isEpicDatesChanged: false,
			isStatusChanged: false,
			project: {
				locationId: 0,
				projectName: '',
				goalsAndBenefits: '',
				currentCoachId: '',
				currentProjectManagerId: 0,
				resources: [],
				currentZeroDate: '',
				currentZeroDateLabel: '',
				isSingleLocationProject: false,
				projectLocationId: 0,
				projectKey: '',
				isActive: true,
				waiverStatusId: 0,
			},
			projectWaiverStatus: {
				canRequestProjectWaiver: false,
				disableRequestProjectWaiver: false,
			},
		};
	}

	componentDidMount = async () => {
		await this.loadFilters();
	};

	componentDidUpdate(prevProps) {
		if (this.props.projectId !== prevProps.projectId) {
			this.loadFilters();
		}
	}

	loadFilters = async () => {
		try {
			const response = await this.props.locationDashboardActions.projectsWidgetDrawerFilters(this.props.locationKey, this.props.projectId);
			if (response.type === types.LOAD_PROJECT_WIDGET_DRAWER_FILTERS_SUCCESS) {
				let project = response.payload.project;
				let projectLocationEpicDates = response.payload.projectLocationEpicDates;

				project.currentZeroDate = project.currentZeroDate
					? Moment.utc(project.currentZeroDate).format(DATE_FORMAT)
					: '';
				projectLocationEpicDates = projectLocationEpicDates.map((x) => {
					return { ...x, epicDate: Moment.utc(new Date(x.epicDate)).format(DATE_FORMAT) };
				});

				this.setState({
					projectCoaches: response.payload.projectCoaches,
					projectManagers: response.payload.projectManagers,
					projectLocationEpicDates: projectLocationEpicDates,
					projectWaiverStatus: response.payload.projectWaiverStatus,
					project: project,
				});
			} else if (response.type === types.LOAD_PROJECT_WIDGET_DRAWER_FILTERS_FAILURE) {
				Notification('error', 'Error', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		} finally {
			this.setState({ isLoading: false });
		}
	};

	onContactFormChange = (e) => {
		this.setState({ [e.target.name]: e.target.value });
	};

	onChangeName = (e) => {
		this.setState({
			isProjectNameChanged: true,
			project: { ...this.state.project, projectName: e.target.value },
		});
	};

	onChangeStatus = (name, isChecked) => {
		this.setState({
			isStatusChanged: true,
			project: { ...this.state.project, [name]: isChecked },
		});
	};

	onCoachChange = (id) => {
		this.setState({
			isProjectCoachChanged: true,
			project: { ...this.state.project, currentCoachId: id },
		});
	};

	onProgramManagerChange = (id) => {
		this.setState({
			isProjectManagerChanged: true,
			project: { ...this.state.project, currentProjectManagerId: id },
		});
	};

	onChangeZeroDate = (date) => {
		this.setState({
			isZeroDateChanged: true,
			project: { ...this.state.project, currentZeroDate: date },
		});
	};

	onChangeEpicDate = (projectLocationEpicDate, date) => {
		let { projectLocationEpicDateId } = projectLocationEpicDate;

		this.setState({
			isEpicDatesChanged: true,
			projectLocationEpicDates: this.state.projectLocationEpicDates.map((x) => {
				return x.projectLocationEpicDateId == projectLocationEpicDateId ? { ...x, epicDate: date } : x;
			}),
		});
	};

	onShowContactForm = () => {
		this.setState({ showContactForm: true });
	};

	validateContactForm = () => {
		if (
			this.state.contactSubject &&
			this.state.contactSubject.trim().length > 0 &&
			this.state.contactDescription &&
			this.state.contactDescription.trim().length > 0
		) {
			return true;
		}

		return false;
	};

	validateProjectForm = () => {
		if (
			this.state.project.currentProjectManagerId === 0 ||
			this.state.project.currentZeroDate === '' ||
			this.state.project.currentZeroDate === 'Invalid date' ||
			this.state.project.projectName.trim().length < 1 ||
			this.state.project.currentCoachId === 0
		) {
			return false;
		} else {
			return true;
		}
	};

	onCreateTicket = async () => {
		if (this.validateContactForm()) {
			try {
				const request = {
					subject: this.state.contactSubject,
					description: this.state.contactDescription,
					projectId: this.props.projectId,
					locationId: this.state.project.locationId,
				};
				this.setState({ isLoading: true });
				const response = await this.props.supportActions.createSubscriptionTicket(request);
				if (response.type === types.CREATE_SUBSCRIPTION_TICKET_SUCCESS) {
					Notification(
						'success',
						'Ticket Created',
						'Thank you for submitting your support request.  Please allow 2 business days for a response.'
					);
					this.setState({ showContactForm: false });
				} else if (response.type === types.CREATE_SUBSCRIPTION_TICKET_FAILURE) {
					Notification('error', 'Error', response.payload.message);
				}
			} catch (error) {
				Notification('error', 'Error', error);
			} finally {
				this.setState({ isLoading: false });
			}
		} else {
			this.setState({ isCreateTicketFormValid: false });
		}
	};

	onUpdateProject = async () => {
		if (this.validateProjectForm()) {
			if (this.state.isProjectNameChanged) {
				this.onUpdateProjectName();
			}
			if (this.state.isStatusChanged) {
				this.onUpdateProjectStatus();
			}
			if (this.state.isProjectCoachChanged) {
				this.onUpdateProjectCoach();
			}
			if (this.state.isProjectManagerChanged) {
				this.onUpdateProjectManager();
			}
			if (this.state.isZeroDateChanged) {
				this.onUpdateZeroDate();
			}
			if (this.state.isEpicDatesChanged) {
				this.onUpdateEpicDates();
			}
			this.props.onComplete();
		} else {
			this.setState({ isUpdateProjectFormValid: false });
		}
	};

	onUpdateProjectName = async () => {
		try {
			const result = await this.props.projectActions.updateProjectName(this.props.projectId, this.state.project.projectName);

			if (result.type === types.UPDATE_PROJECT_NAME_SUCCESS) {
				Notification('success', 'Success', 'Project Name updated successfully');
			} else if (result.type === types.UPDATE_PROJECT_NAME_FAILURE) {
				Notification('error', 'An Error Occurred', result.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		}
	};

	onUpdateProjectStatus = async () => {
		try {
			const result = await this.props.projectActions.updateProjectStatus(this.props.projectId, this.state.project.isActive);

			if (result.type === types.UPDATE_PROJECT_STATUS_SUCCESS) {
				Notification('success', 'Success', 'Project Status updated successfully');
			} else if (result.type === types.UPDATE_PROJECT_STATUS_FAILURE) {
				Notification('error', 'An Error Occurred', result.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		}
	};

	onUpdateProjectCoach = async () => {
		try {
			const response = await this.props.projectLocationActions.updateCoach(
				this.state.project.currentCoachId,
				this.props.projectId,
				this.state.project.locationId
			);
			if (response.type === types.UPDATE_PROJECTLOCATION_COACH_SUCCESS) {
				Notification('success', 'Success', 'Project Coach updated successfully');
			} else if (response.type === types.UPDATE_PROJECTLOCATION_COACH_FAILURE) {
				Notification('error', 'An Error Occurred', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		}
	};

	onUpdateProjectManager = async () => {
		try {
			const response = await this.props.projectLocationActions.updateProjectManager(
				[this.state.project.projectLocationId],
				this.state.project.currentProjectManagerId,
				this.state.project.projectKey
			);
			if (response.type === types.UPDATE_PROJECTLOCATION_MANAGER_SUCCESS) {
				Notification('success', 'Success', 'Project Manager updated successfully');
			} else if (response.type === types.UPDATE_PROJECTLOCATION_MANAGER_FAILURE) {
				Notification('error', 'An Error Occurred', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		}
	};

	onUpdateZeroDate = async () => {
		try {
			const response = await this.props.projectLocationActions.updateZeroDate(
				[this.state.project.projectLocationId],
				this.state.project.projectKey,
				this.state.project.currentZeroDate
			);
			if (response.type === types.UPDATE_PROJECTLOCATION_ZERODATE_SUCCESS) {
				Notification('success', 'Success', 'Zero Date updated successfully');
			} else if (response.type === types.UPDATE_PROJECTLOCATION_ZERODATE_FAILURE) {
				Notification('error', 'An Error Occurred', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		}
	};

	onUpdateEpicDates = async () => {
		try {
			//console.log('Update epic dates');
			const response = await this.props.projectLocationActions.updateEpicDates(this.state.projectLocationEpicDates);
			if (response.type === types.UPDATE_PROJECTLOCATION_EPICDATE_SUCCESS) {
				Notification('success', 'Success', 'Epic Dates updated successfully');
			} else if (response.type === types.UPDATE_PROJECTLOCATION_EPICDATE_FAILURE) {
				Notification('error', 'An Error Occurred', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		}
	};

	onRequestWaiver = async () => {
		try {
			const response = await this.props.projectLocationActions.requestWaiver(this.state.project.projectLocationId);

			if (response.type === types.REQUEST_PROJECTLOCATION_WAIVER_SUCCESS) {
				Notification('success', 'Success', 'Request for waiver submitted');
				this.setState({
					project: { ...this.state.project, waiverStatusId: waiverStatuses.Pending },
				});
				await this.loadFilters();
			} else if (response.type === types.REQUEST_PROJECTLOCATION_WAIVER_FAILURE) {
				Notification('error', 'An Error Occurred', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		}
	};

	onDeleteWaiverRequest = async () => {
		try {
			const response = await this.props.projectLocationActions.deleteWaiverRequest(this.state.project.projectLocationId);

			if (response.type === types.DELETE_PROJECTLOCATION_WAIVER_REQUEST_SUCCESS) {
				Notification('success', 'Success', 'Waiver request deleted');
				this.setState({
					project: { ...this.state.project, waiverStatusId: 0 },
				});
			} else if (response.type === types.DELETE_PROJECTLOCATION_WAIVER_REQUEST_FAILURE) {
				Notification('error', 'An Error Occurred', response.payload.message);
			}
		} catch (error) {
			Notification('error', 'Error', error);
		}
	};

	render() {
		return (
			<Drawer isWide={false} title='Project Resources' onSaveClick={this.onUpdateProject} saveText='Update' onCancelClick={this.props.onCancel}>
				<LoadingIndicator isLoading={this.state.isLoading}>
					<div className='project-widget-drawer'>
						<form name='updateProjectForm' noValidate className={this.state.isUpdateProjectFormValid ? '' : 'was-validated'}>
							<div className='detail-section'>
								<div className='title'>Project Name</div>
								<InputText
									name='name'
									placeholder='Project Name'
									type='text'
									value={this.state.project.projectName}
									onChange={this.onChangeName}
									isRequired={true}
									errorMessage='Project Name is required'
									maxLength={100}
									isDisabled={!this.state.project.isSingleLocationProject || !this.props.isAdminRole}
								/>
							</div>
						{this.state.project.goalsAndBenefits?.trim() && (
							<div className='detail-section'>
								<div className='title'>Goals and Benefits</div>
								<p className='mt-1' style={{ whiteSpace: 'pre-wrap' }}>{this.state.project.goalsAndBenefits.trim()}</p>
								</div>
							)}
							<div className='detail-section'>
								<div className='title'>Project Coach</div>
								<MultiSelectBox
									name='currentCoachId'
									idField='id'
									valueField='name'
									options={this.state.projectCoaches}
									selectedValues={this.state.project.currentCoachId ? this.state.project.currentCoachId.toString() : '0'}
									onChange={this.onCoachChange}
									isRequired={true}
									errorMessage='Project Coach is Required'
									isMulti={false}
								/>
							</div>

							{this.state.projectWaiverStatus.canRequestProjectWaiver && (
								<div className='detail-section'>
									<div className='title'>Project Waiver</div>
									<div className='row no-gutters mt-1'>
										<div className='col-9 pr-3'>
											{this.state.projectWaiverStatus.disableRequestProjectWaiver
												? 'A project waiver has already been processed. If you have questions, please reach out to the project implementation manager.'
												: 'If this project does not apply to your team, you may request a waiver. You will be sent an email when the request is approved/denied.'}
										</div>
										<div className='col-3'>
											{this.state.projectWaiverStatus.disableRequestProjectWaiver ? (
												<Fragment>
													<Button
														name='waiverButton'
														type='button'
														text='Not Approved'
														bootstrapClass='secondary'
														disabled
													/>
													{this.state.project.waiverStatusId === waiverStatuses.Pending && (
														<Button
															name='deleteWaiverRequestButton'
															type='button'
															text='Delete Request'
															bootstrapClass='link'
															onClick={this.onDeleteWaiverRequest}
														/>
													)}
												</Fragment>
											) : (
												<Button
													name='waiverButton'
													type='button'
													text='Request'
													bootstrapClass='primary'
													onClick={this.onRequestWaiver}
												/>
											)}
										</div>
									</div>
								</div>
							)}

							<div className='detail-section'>
								<div className='title mb-2'>Dates</div>
								<DatePicker
									showIcon
									value={this.state.project.currentZeroDate}
									name='currentZeroDate'
									onChange={this.onChangeZeroDate}
									isRequired={true}
									errorMessage='Zero Date is required'
									isDisabled={!this.state.project.isSingleLocationProject || !this.props.isAdminRole}
									label={`${this.state.project.currentZeroDateLabel} Date`}
								/>

								{this.state.projectLocationEpicDates.map((x) => (
									<DatePicker
										showIcon
										key={x.ordinal}
										value={x.epicDate}
										name={x.epicDateLabel}
										onChange={(date) => this.onChangeEpicDate(x, date)}
										// isRequired={true}
										// errorMessage="Zero Date is required"
										isDisabled={!this.props.isAdminRole}
										label={`${x.epicDateLabel} Date`}
									/>
								))}
							</div>
							<div className='detail-section'>
								<div className='title'>Project Implementation Manager</div>
								<MultiSelectBox
									name='currentProjectManagerId'
									idField='id'
									valueField='name'
									options={this.state.projectManagers}
									selectedValues={this.state.project.currentProjectManagerId.toString()}
									onChange={this.onProgramManagerChange}
									isRequired={true}
									errorMessage='Project Manager is required'
									isMulti={false}
									isDisabled={!this.state.project.isSingleLocationProject || !this.props.isAdminRole}
								/>
							</div>
						</form>
						<form
							name='createTicketForm'
							noValidate
							className={(this.state.isCreateTicketFormValid ? '' : 'was-validated') + ' contact-form'}>
							{this.state.showContactForm ? (
								<div className='mt-3 mb-3'>
									<InputText
										name='contactSubject'
										label='Subject'
										type='text'
										placeholder='Subject'
										value={this.state.contactSubject}
										onChange={this.onContactFormChange}
										isRequired={true}
										errorMessage='Subject is Required'
									/>
									<TextArea
										name='contactDescription'
										label='Comment'
										placeholder='Comment'
										value={this.state.contactDescription}
										onChange={this.onContactFormChange}
										isRequired={true}
										rows={3}
										errorMessage='Comment is Required'
									/>
									<Button
										name='contactButton'
										type='button'
										text='Create Ticket'
										bootstrapClass='secondary float-end'
										onClick={this.onCreateTicket}
									/>
									<br />
								</div>
							) : (
								<div className='show-contact'>
									<Button name='contact' type='button' text='Contact' bootstrapClass='link' onClick={this.onShowContactForm} />
								</div>
							)}
						</form>

						<div className='detail-section resources'>
							<div className='title'>Project Resources</div>
							{this.state.project.resources.map((resource) => (
								<div key={resource.id} className='row no-gutters mt-1'>
									<span className='col-1'>
										<Icon name='link' />
									</span>
									<a className='col-11' href={resource.url} target='_blank' rel='noopener noreferrer'>
										{resource.name}
									</a>
								</div>
							))}
						</div>
						<Toggle
							name='isActive'
							text='Project Active'
							checked={this.state.project.isActive}
							onChange={this.onChangeStatus}
							isDisabled={!this.state.project.isSingleLocationProject || !this.props.isAdminRole}
						/>
					</div>
				</LoadingIndicator>
			</Drawer>
		);
	}
}

ProjectsWidgetDrawer.propTypes = {
	locationDashboardActions: PropTypes.object.isRequired,
	projectLocationActions: PropTypes.object.isRequired,
	projectActions: PropTypes.object.isRequired,
	supportActions: PropTypes.object.isRequired,
	onComplete: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	locationKey: PropTypes.string.isRequired,
	projectId: PropTypes.number.isRequired,
	isAdminRole: PropTypes.bool.isRequired,
	onRequestWaiver: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
	return {
		supportActions: bindActionCreators(supportActions, dispatch),
		projectLocationActions: bindActionCreators(projectLocationActions, dispatch),
		projectActions: bindActionCreators(projectActions, dispatch),
	};
}

export default connect(null, mapDispatchToProps)(ProjectsWidgetDrawer);
